import { Dispatch } from 'redux';
import Echo from 'laravel-echo';

import Municipality from '../../types/Municipality';

import {
  addMunicipality,
  updateMunicipality,
  deleteMunicipality,
} from '../../redux/reducers/MunicipalitiesReducer';

export default function subscribeToMunicipalitiesChannel(
  echo: Echo,
  dispatch: Dispatch,
) {
  echo
    .private('municipalities')
    .listen(
      'Municipalities\\MunicipalityCreated',
      ({ municipality }: { municipality: Municipality }) => {
        dispatch(addMunicipality(municipality));
      },
    );

  echo
    .private('municipalities')
    .listen(
      'Municipalities\\MunicipalityUpdated',
      ({ municipality }: { municipality: Municipality }) => {
        dispatch(updateMunicipality(municipality));
      },
    );

  echo
    .private('municipalities')
    .listen('Municipalities\\MunicipalityDeleted', ({ id }: { id: number }) => {
      dispatch(deleteMunicipality(id));
    });
}
